import { Folder } from "../../redux/interfaces/folder.types.ts";

export const hasCollateral = (folder: Folder): boolean => {
  const subfolders =
    folder.subfolders?.map((subfolder) => subfolder.slug) || [];
  return subfolders.includes("collateral");
};
